import { apiClient } from './client'
import type { CursorPage } from './accounts'
import type { VersionSetView } from '../types/versionSet'

/**
 * `GET /api/v1/version-sets` (IB-167) — the pinned VersionSet catalog for this tenant, newest
 * pinned first. Read-only: the table is append-only, and this module publishes no write path.
 */
export async function listVersionSets(signal?: AbortSignal): Promise<CursorPage<VersionSetView>> {
  const { data } = await apiClient.get<CursorPage<VersionSetView>>('/version-sets', { signal })
  return data
}
